import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { InboxAnalyticsEffects } from './_state/inbox-analytics.effects';
import { InboxEffects } from './_state/inbox.effects';
import { InboxStateKey } from './_state/inbox.model';
import { inboxReducer } from './_state/inbox.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(InboxStateKey, inboxReducer),
    EffectsModule.forFeature([InboxEffects, InboxAnalyticsEffects]),
  ],
})
export class InboxNgrxModule {}
